import Auth from '@/screens/Auth/components/Main';
import AuthLogout from '@/screens/Auth/components/Logout';
import AuthStartLogout from '@/screens/Auth/components/StartLogout';
import AuthSurrogate from '@/screens/Auth/components/Surrogate';
import EmailList from '@/Emails';
import Locations from '@/Locations';
import Show from '@/Show';
import rebrand from '../config/rebrand';

export default [
  {
    path: '/',
    name: 'Index',
    beforeEnter: () => {
      window.location.replace(rebrand.urls.KLICKART_URL);
    },
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
  },
  {
    path: '/auth/login',
    name: 'Auth',
    component: Auth,
  },
  {
    path: '/auth/renew',
    name: 'Renew',
    component: Auth,
  },
  {
    path: '/auth/start-logout',
    name: 'Start-Logout',
    component: AuthStartLogout,
  },
  {
    path: '/auth/logout',
    name: 'Logout',
    component: AuthLogout,
  },
  {
    path: '/auth/surrogate',
    name: 'Surrogate',
    component: AuthSurrogate,
  },
  {
    path: '/:pageIdentifier',
    name: 'Show',
    component: Show,
  },
  {
    path: '/:pageIdentifier/emails',
    name: 'EmailList',
    component: EmailList,
  },
  {
    path: '/:pageIdentifier/locations',
    name: 'Locations',
    component: Locations,
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js